export default function FilterChip({ children, active, onClick, tokens }) {
  return (
    <button
      className="gl-btn-bare"
      onClick={onClick}
      style={{
        fontFamily: tokens.fontMono,
        fontSize: 10.5,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        borderRadius: 999,
        padding: '6px 14px',
        border: `1px solid ${active ? tokens.accent : tokens.edge}`,
        color: active ? tokens.accent : tokens.textLow,
        background: active ? tokens.accentGlow : 'transparent',
        transition: `all 200ms ${tokens.ease}`,
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}
